import { CircularProgress } from 'libs/ui';

import { LoadingViewStyled } from './LoadingView.styles';

export const LoadingView = () => (
  <LoadingViewStyled alignItems="center" justifyContent="center">
    <CircularProgress color="success" size={40} />
  </LoadingViewStyled>
);
